import { connect } from "react-redux";
import { getInLanDongLai } from "actions/InLanDongLai";
import inDanhSach from "components/CommonComponent/InDanhSachPhiKhac";

const mapStateToProps = (state) => ({
  inlandonglai: state.inlandonglai,
});

const mapDispatchToProps = (dispatch) => ({
  getInLanDongLai: (dataSearch) => dispatch(getInLanDongLai(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(inDanhSach);
